/**
 * Help menu — persistent header entry.
 * Chapter "HELP MENU" of the Trust & Support ask.
 */
import { HelpCircle, BookOpen, LifeBuoy, Bug, Sparkles, Activity, ShieldCheck, Keyboard, Rocket, Megaphone, MessageSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function HelpMenu() {
  const navigate = useNavigate();
  const soon = (label) => toast.info(`${label} — coming next in this hardening pass.`);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9" data-testid="help-menu-trigger" aria-label="Help">
          <HelpCircle className="h-4 w-4 text-slate-500" strokeWidth={1.5} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-slate-500">Help & Trust</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => navigate("/help")} data-testid="help-item-centre">
          <BookOpen className="h-4 w-4 mr-2 text-slate-500" /> Help centre
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => soon("Getting started tour")}>
          <Rocket className="h-4 w-4 mr-2 text-slate-500" /> Getting started
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/help/status")}>
          <Activity className="h-4 w-4 mr-2 text-slate-500" /> System status
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/whats-new")} data-testid="help-item-whats-new">
          <Sparkles className="h-4 w-4 mr-2 text-slate-500" /> What's new
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/notices")} data-testid="help-item-notices">
          <Megaphone className="h-4 w-4 mr-2 text-slate-500" /> Advance notices
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/feedback")} data-testid="help-item-feedback">
          <MessageSquare className="h-4 w-4 mr-2 text-slate-500" /> Feedback
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/help/trust")} data-testid="help-item-trust">
          <ShieldCheck className="h-4 w-4 mr-2 text-slate-500" /> Security & privacy
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/help/accessibility")} data-testid="help-item-a11y">
          <Sparkles className="h-4 w-4 mr-2 text-slate-500" /> Accessibility
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => window.location.href = "mailto:support@suntronix.one"}>
          <LifeBuoy className="h-4 w-4 mr-2 text-slate-500" /> Contact support
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/feedback")}>
          <Bug className="h-4 w-4 mr-2 text-slate-500" /> Report a problem
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => soon("Keyboard shortcuts")}>
          <Keyboard className="h-4 w-4 mr-2 text-slate-500" /> Keyboard shortcuts
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
